import { useState } from "react";
import { API } from "@/lib/api";

export function SecureImage({ fileId, alt, className }) {
  const [failed, setFailed] = useState(false);
  const src = `${API}/admin/files/${fileId}`;

  if (failed) {
    return <div className={`flex items-center justify-center bg-slate-800 text-xs text-slate-500 ${className}`}>Image unavailable</div>;
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setFailed(true)} />;
}
